import { matchPath } from 'react-router-dom';
export var PREVIEW_TYPE = {
    TESTING: 'testing-preview',
    STYLES: 'styles-preview'
};
export var BASE_URLS = {
    DEFAULT: '/:widgetId',
    PREVIEW: '/:widgetId/:previewType/:previewHash'
};
export var DEFAULT_ENDPOINTS = {
    CMS: 'https://widgetstate-dev.votenow.tv/v3/state/',
    CONNECT: 'https://voteapi-dev.votenow.tv/s2/vote',
    PREVIEW: 'https://ssp-api-dev.votenow.tv/v1/widget_previews/'
};
function getAppConfig() {
    // tsReactInitConfig is set in index.html when we do npm run build . Default values are set here for local webpack devserver testing.
    var tsReactInitConfig = window.tsReactInitConfig || {};
    var _a = tsReactInitConfig.widgetStateUrl, widgetStateUrl = _a === void 0 ? DEFAULT_ENDPOINTS.CMS : _a, _b = tsReactInitConfig.connectUrl, connectUrl = _b === void 0 ? DEFAULT_ENDPOINTS.CONNECT : _b, _c = tsReactInitConfig.previewUrl, previewUrl = _c === void 0 ? DEFAULT_ENDPOINTS.PREVIEW : _c;
    var isPreviewUrl = isPreview();
    var basenamePattern = isPreviewUrl ? BASE_URLS.PREVIEW : BASE_URLS.DEFAULT;
    var match = matchPath(window.location.pathname, { path: basenamePattern });
    var urlParams = match === null || match === void 0 ? void 0 : match.params;
    var basename = Object.entries(urlParams)
        .reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        return acc.replace(":".concat(key), value);
    }, basenamePattern);
    // CMSify
    var appHash = (urlParams === null || urlParams === void 0 ? void 0 : urlParams.previewHash) || (urlParams === null || urlParams === void 0 ? void 0 : urlParams.widgetId) || '';
    var widgetUrl = isPreviewUrl ? previewUrl : widgetStateUrl;
    var shouldPollWidget = !isPreviewUrl;
    var widgetId = urlParams === null || urlParams === void 0 ? void 0 : urlParams.widgetId;
    // Connect
    var isDevMode = (urlParams === null || urlParams === void 0 ? void 0 : urlParams.previewType) === PREVIEW_TYPE.STYLES;
    return {
        isPreviewUrl: isPreviewUrl,
        basenamePattern: basenamePattern,
        basename: basename,
        urlParams: urlParams,
        appHash: appHash,
        widgetUrl: widgetUrl,
        shouldPollWidget: shouldPollWidget,
        widgetId: widgetId,
        isDevMode: isDevMode,
        connectUrl: connectUrl
    };
}
function isPreview() {
    var _a;
    var pattern = '/:widgetId/:param/';
    var match = matchPath(window.location.pathname, { path: pattern });
    var param = (_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.param;
    return param === PREVIEW_TYPE.STYLES || param === PREVIEW_TYPE.TESTING;
}
export default getAppConfig;
